/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SignAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Empty from './Empty/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SignAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/SignAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payorContractValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'contract',
})
let payorContractSignatureRequestValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'contract.signature_request',
})
let aggregateData = fromHelpers.getView(payorContractValueData, payorContractSignatureRequestValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}